// deno-fmt-ignore-file
import { Guard } from '../../guard/index.mjs';
import { Try } from './try/index.mjs';
export function FromBigInt(context, type, value) {
    if (Guard.IsBigInt(value))
        return value;
    const result = Try.TryBigInt(value);
    return Try.IsOk(result) ? result.value : value;
}
